import { createFileRoute } from "@tanstack/react-router";
import { ConnectKey } from "../../../features/infrastructure/cloud-key";

export const Route = createFileRoute("/_authed/$org/infrastructure/cloudaccounts/new/key")({
  component: Page,
  validateSearch: (s: Record<string, unknown>): { cloud?: string; name?: string; mode?: string } => ({
    ...(typeof s.cloud === "string" ? { cloud: s.cloud } : {}),
    ...(typeof s.name === "string" ? { name: s.name } : {}),
    ...(typeof s.mode === "string" ? { mode: s.mode } : {}),
  }),
});

function Page() {
  const { org } = Route.useParams();
  const { cloud, name, mode } = Route.useSearch();
  return <ConnectKey org={org} initialCloud={cloud} initialName={name} initialMode={mode} />;
}
